import React from 'react';
import { AttachmentComponent, EntityType, useParams } from '../../utils/globalImports';

const Attachments: React.FC = () => {
    const {projectId} = useParams<{ projectId: string }>();
    
    return (
        <AttachmentComponent
        entityTypeId={EntityType.Project}
        entityId={Number(projectId)}
        resourceId={Number(projectId)}
        title="Proposal Attachments"
        searchbarText="Search for attachments"
      />
    );
};

export default Attachments;